export default __webpack_public_path__ + "static/media/sidebar-3.482940f2.jpg";